// extracted by mini-css-extract-plugin
module.exports = {"announcement-dialog":"AnnouncementDialog_announcement-dialog__SRpAd","title":"AnnouncementDialog_title__LG9oL","description":"AnnouncementDialog_description__sN38n"};